import { FeatureFlag } from 'modules/featureFlags/types';

import { createEnabledFractionsForIds } from './createEnabledFractionsForIds';
import { createDisabledFractionsForIds } from './createDisabledFractionsForIds';

export const getProjectIdFractionsFromSettings = (settings: FeatureFlag['settings']) =>
  'projectIdFractions' in settings
    ? settings.projectIdFractions
    : {
        ...createEnabledFractionsForIds(settings.enabledProjectIds),
        ...createDisabledFractionsForIds(settings.disabledProjectIds),
      };
